import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
const PDFViewer = () => {
    var _a;
    return (_jsx("div", { children: _jsx("iframe", { title: "PDF Viewer", src: ((_a = process.env.REACT_APP_API_BASE_URL) === null || _a === void 0 ? void 0 : _a.split("/api")[0]) +
                "/StaticFiles/Algemene voorwaarden.pdf", width: "100%", height: `${window.innerHeight - 200}`, allowFullScreen: true, style: { borderRadius: "12px" } }) }));
};
export default PDFViewer;
